<script setup lang="ts">
import DatePickerField from '@/components/Fields/DatePickerField.vue'
import StackLayout from '@/components/Layouts/StackLayout.vue'
import { moment } from '@/locales/langUtils'
import type { EventFilters } from '@/types/filters/EventFilters'
import DebouncedInputField from '../../../components/Fields/DebouncedInputField.vue'

type Props = {
    filters: EventFilters
}

defineProps<Props>()
type Emits = {
    (e: 'change', value: Partial<EventFilters>): void
}
defineEmits<Emits>()
</script>

<template>
    <StackLayout :gap="8" class="full-width" isResponsive>
        <DebouncedInputField
            :label="$t('event.filters.eventName')"
            :modelValue="filters.name"
            @change="$emit('change', { name: $event })" />
        <StackLayout :gap="8" isResponsiveSmallScreen>
            <DatePickerField
                :label="$t('event.filters.startDate')"
                :modelValue="filters.start_at ? moment(filters.start_at).toDate() : undefined"
                @change="
                    $emit('change', {
                        start_at: $event ? moment($event).startOf('d').utc().toDate() : $event
                    })
                "
                clearable
                class="full-width" />
            <DatePickerField
                :label="$t('event.filters.endDate')"
                :modelValue="filters.end_at ? moment(filters.end_at).toDate() : undefined"
                @change="
                    $emit('change', {
                        end_at: $event ? moment($event).endOf('d').utc().toDate() : $event
                    })
                "
                clearable
                class="full-width" />
        </StackLayout>
    </StackLayout>
</template>
